import { ChatMessage } from '../../types/Support';

/** Round 2 F7: who wrote a chat line — staff on the right (you darker), the customer on the left, bot / system centred. */
export type SenderKind = 'me' | 'staff' | 'customer' | 'bot' | 'system';

const isStaffMessage = (m: ChatMessage) =>
    m.senderType === 'agent' || m.agentId != null || m.senderUid === 'ADMIN_SUPPORT' || (!m.senderType && /^\d+$/.test(String(m.senderUid))); // old rows: staff ids are numbers

export const senderKind = (m: ChatMessage, myId: string | number | null | undefined): SenderKind => {
    if (m.kind === 'system' || m.senderType === 'system') return 'system';
    if (m.isBot || m.senderType === 'bot') return 'bot';
    if (isStaffMessage(m)) {
        const mine = myId != null && myId !== '' && (String(m.agentId ?? m.senderUid) === String(myId) || String(m.senderUid) === String(myId));
        return mine ? 'me' : 'staff';
    }
    return 'customer';
};

const ROLE: Record<string, string> = { rider: 'Rider', driver: 'Driver', guest: 'Guest' };

/** The small name over a bubble: "You", the agent's name, "Rider" / "Driver", "Bot". */
export const senderLabel = (m: ChatMessage, kind: SenderKind, opts: { staffName?: (id: string) => string | undefined; customerRole?: string | null } = {}): string => {
    if (kind === 'me') return 'You';
    if (kind === 'bot') return 'Bot';
    if (kind === 'system') return '';
    if (kind === 'staff') return m.senderName || opts.staffName?.(String(m.agentId ?? m.senderUid)) || 'Support agent';
    // Adversarial R1: the side the ticket was raised as wins — a driver account in the rider app sends senderType 'driver'.
    return ROLE[opts.customerRole ?? ''] ?? ROLE[m.senderType ?? ''] ?? 'Customer';
};
